import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";
import EventTypes from "../shared/EventTypes";

export default class Grid extends AbstractProvidedClass {
    minGrey = 230;
    maxGrey = 180;
    minMinor = 5;
    minorSize = 10;
    dimensions = [];
    timelineHeight = 0;

    constructor(provider) {
        super(provider);
        this.on(EventTypes.UPDATE_UNIT_SYSTEM, (isMetric) => this.recalculate(isMetric));
        this.on(EventTypes.TIMELINE_TOGGLED, (barHeight) => this.timelineHeight = barHeight);
    }

    display(g) {
        if (!this.settings.showGrid) {
            return;
        }

        g.strokeWeight(1);
        this.dimensions.map((dim) => {
            let px = dim * this.view.scale;
            if (px < 10) {
                return;
            }
            g.stroke(dim.color, this.settings.showImage ? 100 : 255);
            this.displayVerticals(g, dim.currentSize);
            this.displayHorizontals(g, dim.currentSize);
        });

        g.strokeWeight(2);
        g.stroke(this.maxGrey);
        // 0 vertical
        g.line(this.view.posX, 0, this.view.posX, g.height);
        // 0 horizontal
        g.line(0, this.view.posY, g.width, this.view.posY);
    }

    displayVerticals(g, currentSize) {
        for (let x = (this.view.posX % currentSize); x < g.width; x += currentSize) {
            g.line(x, 0, x, g.height);
        }
    }

    displayHorizontals(g, currentSize) {
        for (let y = (this.view.posY % currentSize); y < g.height; y += currentSize) {
            g.line(0, y, g.width, y);
        }
    }

    displayLegend(g) {
        g.strokeWeight(1);
        let leftSpace = 10;
        let bottomSpace = 5 + (this.editMode ? TIP_BAR_HEIGHT + this.timelineHeight : 5);
        let legendWidth = this.dimensions[1].currentSize + 20;
        let legendHeight = 30;
        let x = leftSpace;
        let y = g.height - legendHeight - bottomSpace;

        g.rectMode(g.CORNER);
        g.stroke(0);
        g.fill(this.provider.backgroundColor);
        g.rect(x, y, legendWidth, legendHeight);

        g.stroke(this.dimensions[1].color);
        for (let i = x + 10; i < x + legendWidth - 10; i += this.dimensions[0].currentSize) {
            g.line(i, y + 15, i, y + 25);
        }

        g.stroke(0);
        // verticals
        g.line(x + 10, y + 15, x + 10, y + 25);
        g.line(x + 10 + this.dimensions[1].currentSize, y + 15, x + 10 + this.dimensions[1].currentSize, y + 25);
        // horizontal
        g.line(x + 10, y + 20, x + 10 + this.dimensions[1].currentSize, y + 20);

        g.noStroke();
        g.fill(0);
        g.textFont('Helvetica');
        g.textSize(10);
        g.textAlign(g.CENTER);
        g.text(this.getLegendScale(), x + legendWidth / 2, y + 12);
    }

    recalculate(isMetric = null) {
        this.dimensions = [];
        this.minorSize = null;
        this.getDimensions(isMetric).forEach((dim) => {
            let currentSize = dim.absSize * this.view.scale;
            if (currentSize < this.minMinor) {
                return;
            }
            if (!this.minorSize) {
                this.minorSize = currentSize;
            }
            this.dimensions.push({
                absSize: dim.absSize,
                currentSize: currentSize,
                label: dim.label,
                color: this.p.map(currentSize, 10, 200, this.minGrey, this.maxGrey, true),
            });
        });
    }

    getLegendScale() {
        return this.dimensions[1].label + ' / ' + this.dimensions[0].label;
    }

    getDimensions(isMetric = null) {
        isMetric ??= this.settings.metric;
        return isMetric ? this.metricDimensions : this.imperialDimensions;
    }

    get metricDimensions() {
        return [
            { absSize: 1, label: '1 cm' },
            { absSize: 10, label: '10 cm' },
            { absSize: 100, label: '1 m' },
            { absSize: 1000, label: '10 m' },
            { absSize: 10000, label: '100 m' },
            { absSize: 100000, label: '1 km' },
        ];
    }

    get imperialDimensions() {
        return [
            { absSize: 2.54, label: '1 in' },
            { absSize: 30.48, label: '1 ft' },
            { absSize: 304.8, label: '10 ft' },
            { absSize: 3048, label: '100 ft' },
            { absSize: 30480, label: '1000 ft' },
            { absSize: 304800, label: '10k ft' },
        ]
    }
}
